import global from '../config/global'

export default {
  splitFileName: function (text) {
    return text.substr(0, text.lastIndexOf('.'))
  },
  buildImageKeyMini: function (pathname) {
    return global.mediaUrl + '/final/' + pathname + '/image@key_mini.jpg'
  },
  buildImage: function (pathname) {
    return global.mediaUrl + '/final/' + pathname + '/image.jpg'
  },
  buildImagePoster: function (pathname) {
    return global.mediaUrl + '/final/' + pathname + '/image@poster.jpg'
  },
  buildImageAvatar: function (pathname) {
    return global.mediaUrl + '/final/' + pathname + '/image@avatar.jpg'
  },
  buildVideo720: function (pathname) {
    return global.mediaUrl + '/final/' + pathname + '/video@720p.mp4'
  },
  buildTempImage: function (pathname) {
    return global.mediaUrl + '/temp/' + pathname + '/image.jpg'
  },
  buildTempVideo: function (pathname) {
    return global.mediaUrl + '/temp/' + pathname + '/video.mp4'
  },
  formatSeconds: function (a) {
    let hh = parseInt(a / 3600)
    if (hh < 10) hh = '0' + hh
    let mm = parseInt((a - hh * 3600) / 60)
    if (mm < 10) mm = '0' + mm
    let ss = parseInt((a - hh * 3600) % 60)
    if (ss < 10) ss = '0' + ss
    let length = hh + ':' + mm + ':' + ss
    if (a > 0) {
      return length
    } else {
      return '00:00:00'
    }
  },
  formatB2MByte: function (b) {
    let mb = parseInt(b / 1024 / 1024)
    return mb
  },
  generalTimePrint: function (date, fmt) {
    let o = {
      'M+': date.getMonth() + 1, // 月份
      'd+': date.getDate(), // 日
      'h+': date.getHours(), // 小时
      'm+': date.getMinutes(), // 分
      's+': date.getSeconds(), // 秒
      'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
      'S': date.getMilliseconds() // 毫秒
    }
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    for (let k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
      }
    }
    return fmt
  }
}



// WEBPACK FOOTER //
// ./src/utils/tool.js